const dateFormat = "MM/DD/YYYY"
const dateFormatForBackend = "YYYY/MM/DD"

export { dateFormat, dateFormatForBackend }
